import React, { useState } from "react";
import MuiSearchSelect from "../../../../components/basicComponent/MuiSearchSelect";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

interface OptionType {
  label: string;
  value: string;
}

interface HotelSubHeaderCardProps {
  onSortChange: (sortBy: string) => void;
  totalCount: number;
  city: string;
  country: string;
  loading: boolean;
}

const HotelSubHeaderCard: React.FC<HotelSubHeaderCardProps> = ({
  onSortChange,
  totalCount,
  city,
  country,
  loading,
}) => {
  const sortOptions: OptionType[] = [
    { label: "Popularity", value: "Popularity" },
    { label: "Price: Low to High", value: "Price: Low to High" },
    { label: "Price: High to Low", value: "Price: High to Low" },
    { label: "Rating", value: "Rating" },
  ];

  const [selectedSort, setSelectedSort] = useState<string>("");

  const handleSortChange = (value: string) => {
    setSelectedSort(value);
    onSortChange(value);
  };

  return (
    <div className="card mb-3 ">
      <div className="container py-2">
        <div className="row align-items-center justify-content-between">
          {/* Hotel Count Info */}
          {!loading && (
            <div className="col-md-6 col-12 mb-2 mb-md-0 d-flex align-items-center">
              <AccountBalanceIcon className="me-2" />
              <span className="fs-5 fw-medium text-dark">
                {totalCount} Hotels in {city}
              </span>
            </div>
          )}

          {/* Sort Dropdown */}
          <div className="col-md-6 col-12 d-flex justify-content-md-end">
            {loading ? (
              <div
                className="w-50"
                style={{
                  height: "40px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                }}
              ></div>
            ) : (
              <div className=" w-50 hotel-search-input">
                <MuiSearchSelect
                  placeholder="Sort by"
                  options={sortOptions}
                  value={selectedSort}
                  onChange={handleSortChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelSubHeaderCard;
